import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

// GoPeople only sends the code to digits with an optional leading "+", 10 to 15
// of them: a number the phone library accepts, such as "+32 470 12 34 56", is
// still refused there unless it is sent normalized.
const GOPEOPLE_PHONE = /^\+?\d{10,15}$/;

// The E.164 form the phone input works with and GoPeople is sent. A number
// stored with spaces, a 00 prefix or in national form is converted, Belgian by
// default like the input; one that cannot be parsed is returned unchanged.
export const normalizeStudentPhone = (value) => {
  if (!value) {
    return "";
  }
  try {
    return parsePhoneNumber(value, "BE")?.number || value;
  } catch (e) {
    return value;
  }
};

export const isStudentPhoneValid = (value) => {
  const phone = normalizeStudentPhone(value);
  return (
    Boolean(phone) && isValidPhoneNumber(phone) && GOPEOPLE_PHONE.test(phone)
  );
};

// The phone the step starts on: the first valid listed number, else "Autre"
// with the first listed number in the input for the student to correct.
export const pickStudentPhone = (phones) => {
  const listed = phones || [];
  const valid = listed.find(isStudentPhoneValid);
  if (valid) {
    return { phone: valid, otherPhone: false };
  }
  return {
    phone: listed.length > 0 ? normalizeStudentPhone(listed[0]) : "",
    otherPhone: true,
  };
};
